/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.1
 */

import styled from 'styled-components';

export const DragAndDropContainerStyled = styled.div.attrs({
    className: 'drag-and-drop',
})`
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    padding: 24px 40px 0;
`;

export const DragAndDropColumnContainerStyled = styled.div.attrs({
    className: 'drag-and-drop__column',
})`
    display: inline-flex;
    flex-basis: 384px;
    flex-direction: column;
    align-content: space-between;
    max-width: 33%;
    box-sizing: border-box;
    
    &:first-child {
        padding-left: 0;
    }
    
    &:last-child {
        padding-right: 0;
    }
   
`;
